module.exports = __webpack_public_path__ + "static/img/weinengfanxiangnengrenku_xuan.fa071da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav/weinengfanxiangnengrenku_xuan.png
// module id = dY88
// module chunks = 22